<template>
  <div class="side_bar__wrapper fix-navbar">
    <SuspendedModal
      :statusInfo="statusInfo"
      :branch="false"
      :industry="true"
    ></SuspendedModal>
    <WarningModal
      :statusInfo="statusInfo"
      :branch="false"
      :industry="true"
    ></WarningModal>
    <!-- <section
      class="sidebar use-tiny-scroll"
      :class="collapseNavbar ? 'collapsed' : ''"
      @mouseover="toggleSidenavText"
      @mouseleave="hideTitles"
    > -->
    <div
      class="side__bar"
      id="mlDiv"
      :style="[
        windowLoc == 'interswitchenergy'
          ? { backgroundColor: '#11386a' }
          : windowLoc == 'rainoil'
          ? { backgroundColor: '#0a0044' }
          : windowLoc == 'eterna'
          ? { backgroundColor: '#007236' }
          : windowLoc == 'bovas'
          ? { backgroundColor: '#b28b00' }
          : null,
      ]"
    >
      <div class="side_bar_Logo text-center">
        <div class="text-center mt-3">
          <img src="@/assets/img/epump_white_logo.svg" width="150" />
        </div>
      </div>
      <div>
        <ul class="list-group mt-4" style="">
          <!-- ADMIN DASHBOARD -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_dashboard'
                ? 'navbar_item_active'
                : null,
            ]"
          >
            <router-link
              :to="{
                name: 'industrial_admin_dashboard',
                query: {
                  branchId: this.$route.query.branchId,
                  companyID: this.$route.query.companyID,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img alt="" src="@/assets/img/dashboard (1).png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.iAdminMasterLayout.dashboard") }}
              </span>
            </router-link>
          </li>

          <!-- SITES LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_branches'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Site') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_branches',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <svg
                  class="pl-1"
                  width="20"
                  height="20"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.85714 3.42845C6.8574 4.23888 6.57057 5.0232 6.04754 5.64226C5.52451 6.26132 4.7991 6.67509 4 6.81016V9.14273H10.2857C10.7404 9.14273 11.1764 8.96212 11.4979 8.64063C11.8194 8.31914 12 7.8831 12 7.42844V6.81016C11.1523 6.66688 10.3894 6.21039 9.86249 5.53115C9.33553 4.85191 9.08297 3.99949 9.15487 3.14283C9.22676 2.28616 9.61785 1.48776 10.2506 0.905846C10.8834 0.323933 11.7117 0.000976562 12.5714 0.000976562C13.4311 0.000976562 14.2594 0.323933 14.8922 0.905846C15.525 1.48776 15.9161 2.28616 15.988 3.14283C16.0599 3.99949 15.8073 4.85191 15.2804 5.53115C14.7534 6.21039 13.9905 6.66688 13.1429 6.81016V7.42844C13.1429 8.1862 12.8418 8.91293 12.306 9.44875C11.7702 9.98456 11.0435 10.2856 10.2857 10.2856H4V11.4753C4.84766 11.6186 5.61056 12.0751 6.13751 12.7543C6.66447 13.4335 6.91703 14.286 6.84513 15.1426C6.77324 15.9993 6.38215 16.7977 5.74936 17.3796C5.11656 17.9615 4.28825 18.2845 3.42857 18.2845C2.5689 18.2845 1.74059 17.9615 1.10779 17.3796C0.475002 16.7977 0.0839081 15.9993 0.0120164 15.1426C-0.0598754 14.286 0.192682 13.4335 0.719638 12.7543C1.24659 12.0751 2.00949 11.6186 2.85715 11.4753V6.8113C2.21271 6.70237 1.61283 6.41151 1.12819 5.97299C0.643555 5.53447 0.294357 4.96657 0.121743 4.33619C-0.0508719 3.70581 -0.0397113 3.03923 0.15391 2.41499C0.347531 1.79074 0.715545 1.23485 1.21459 0.812798C1.71363 0.39075 2.32291 0.120134 2.97064 0.0328391C3.61837 -0.0544564 4.27755 0.0452053 4.87052 0.320081C5.46349 0.594957 5.96554 1.03359 6.31751 1.58431C6.66949 2.13502 6.85672 2.77487 6.85714 3.42845Z"
                    fill="white"
                  /></svg
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.iAdminMasterLayout.branches") }}
              </span>
            </router-link>
          </li>

          <!-- REPORT -->
          <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_admin_tank_report'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Report') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_report',
                query: { companyID: this.companyID },
              }"
              :class="
                activeRoute === 'industrial_admin_report'
                  ? 'navbar_item_active'
                  : ''
              "
              class="vue_router_link"
            >
              <span class="mr-3"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 14 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0V18.2H14V4.62L13.79 4.41L9.59 0.21L9.38 0H0ZM1.4 1.4H8.4V5.6H12.6V16.8H1.4V1.4ZM9.8 2.38L11.62 4.2H9.8V2.38ZM2.8 7V8.4H11.2V7H2.8ZM2.8 10.5V11.9H7.7V10.5H2.8ZM9.1 10.5V11.9H11.2V10.5H9.1ZM2.8 13.3V14.7H7.7V13.3H2.8ZM9.1 13.3V14.7H11.2V13.3H9.1Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.iGroup.report") }}
              </span>
            </router-link>
          </li>

          <!-- GROUP MANAGEMENT LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_group_management'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              (userInfo.roles.includes('GroupManager') &&
                comPlanFeatures.includes('Group management')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_group_management',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/deal.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.iGroup.groupManagement") }}
              </span>
            </router-link>
          </li>
          <!-- USERS LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_users'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              (userInfo.roles.includes('ManageUsers') &&
                comPlanFeatures.includes('Manage users')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_users',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/users-group.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.iGroup.manageUsers") }}</span
              >
            </router-link>
          </li>

          <!-- MAINTENANCE-->
          <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_admin_maintenance'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Maintenance') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_maintenance',
                query: { companyID: this.companyID },
              }"
              :class="
                activeRoute === 'industrial_admin_maintenance'
                  ? 'navbar_item_active'
                  : ''
              "
              class="vue_router_link"
            >
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.iGroup.maintenance") }}
              </span>
            </router-link>
          </li>

          <!-- WALLET LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_admin_wallet'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Wallet') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_wallet',
                query: { companyID: this.companyID },
              }"
              :class="
                activeRoute === 'industrial_branch_wallet_balance'
                  ? 'navbar_item_active'
                  : ''
              "
              class="vue_router_link"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 16 15"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-3"
                style="color: white"
              >
                <path
                  d="M13.4 3.39999H2.15005V2.94999L12.05 2.15799V2.94999H13.4V1.59999C13.4 0.609988 12.5981 -0.0848123 11.6189 0.0546877L2.58205 1.34529C1.60195 1.48569 0.800049 2.40999 0.800049 3.39999V12.4C0.800049 12.8774 0.989691 13.3352 1.32726 13.6728C1.66482 14.0103 2.12266 14.2 2.60005 14.2H13.4C13.8774 14.2 14.3353 14.0103 14.6728 13.6728C15.0104 13.3352 15.2 12.8774 15.2 12.4V5.19999C15.2 4.7226 15.0104 4.26476 14.6728 3.9272C14.3353 3.58963 13.8774 3.39999 13.4 3.39999ZM12.05 9.70539C11.8727 9.70533 11.6971 9.67034 11.5333 9.60242C11.3695 9.5345 11.2206 9.43498 11.0953 9.30953C10.9699 9.18409 10.8705 9.03518 10.8027 8.87132C10.7349 8.70745 10.7 8.53183 10.7 8.35449C10.7001 8.17715 10.7351 8.00155 10.803 7.83773C10.8709 7.67391 10.9705 7.52507 11.0959 7.39971C11.2213 7.27435 11.3703 7.17492 11.5341 7.10711C11.698 7.0393 11.8736 7.00443 12.0509 7.00449C12.4091 7.00461 12.7526 7.147 13.0057 7.40034C13.2589 7.65369 13.4011 7.99723 13.4009 8.35539C13.4008 8.71355 13.2584 9.05699 13.0051 9.31017C12.7517 9.56334 12.4082 9.70551 12.05 9.70539Z"
                  fill="white"
                />
              </svg>
              <span class="sidenav_list_title">
                {{ $t("text.iAdminMasterLayout.wallet") }}
              </span>

              <!-- <i class="fa fa-angle-right upArrow"></i> -->
            </router-link>
          </li>

          <!-- ORDER MANAGEMENT LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_order_management'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Order management') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_order_management',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/order-processed.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.iAdminMasterLayout.orderManagement") }}
              </span>
            </router-link>
          </li>

          <!-- INVOICES -->
          <!-- <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_invoice'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Invoices') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_invoice',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-3"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 14 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0V18.2H14V4.62L13.79 4.41L9.59 0.21L9.38 0H0ZM1.4 1.4H8.4V5.6H12.6V16.8H1.4V1.4ZM9.8 2.38L11.62 4.2H9.8V2.38ZM2.8 7V8.4H11.2V7H2.8ZM2.8 10.5V11.9H7.7V10.5H2.8ZM9.1 10.5V11.9H11.2V10.5H9.1ZM2.8 13.3V14.7H7.7V13.3H2.8ZM9.1 13.3V14.7H11.2V13.3H9.1Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cInvoice.title") }}
              </span>
            </router-link>
          </li> -->

          <!-- SUPPORT-->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : null,
            ]"
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/svg/support.svg" width="20px"
              /></span>

              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.supportAdmin") }}
              </span>
            </router-link>
          </li>
          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="80px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="80px"
                  height="40px"
                />
              </div>
            </div>
          </div>

          <!-- <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_branch_consumption_report' ||
              activeRoute === 'industrial_branch_tank_transactions' ||
              activeRoute === 'industrial_branch_tanks_filled'
                ? 'navbar_item_active open'
                : ''
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iAdminMasterLayout.reports") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link
                  :to="{
                    name: 'industrial_branch_consumption_report',
                    query: { branchId: this.$route.query.branchId },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_consumption_report'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iAdminMasterLayout.consumptionReport") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'industrial_branch_tank_transactions',
                    query: { branchId: this.$route.query.branchId },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_tank_transactions'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iAdminMasterLayout.transactionHistory") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'industrial_branch_tanks_filled' }"
                  :class="
                    activeRoute === 'industrial_branch_tanks_filled'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iAdminMasterLayout.tanksFilled") }}
                </router-link>
              </li>
            </ul>
          </li>

          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_branch_events'
                ? 'navbar_item_active'
                : null,
            ]"
          >
            <router-link
              :to="{
                name: 'industrial_branch_events',
                query: { branchId: this.$route.query.branchId },
              }"
              class="vue_router_link"
            >
              <i
                class="fa fa-calendar-check-o mr-2"
                aria-hidden="true"
                style="font-size: 18px; color: white"
              ></i>
              {{ $t("text.iAdminMasterLayout.events") }}
            </router-link>
          </li>

          <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrialBranchSchedule_maintenace' ||
              activeRoute === 'industrialBranchAddMaintenance'
                ? 'navbar_item_active open'
                : ''
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iAdminMasterLayout.maintenance") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link
                  :to="{
                    name: 'industrialBranchAddMaintenance',
                    query: { branchId: this.$route.query.branchId },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_consumption_report'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iAdminMasterLayout.addMaintenance") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'industrialBranchSchedule_maintenace',
                    query: { branchId: this.$route.query.branchId },
                  }"
                  :class="
                    activeRoute === 'industrialBranchSchedule_maintenace'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iAdminMasterLayout.schedules") }}
                </router-link>
              </li>
            </ul>
          </li> -->
        </ul>
      </div>
    </div>
    <!-- </section> -->

    <b-navbar toggleable="lg" fixed="top" class="b-nav">
      <!-- <b-navbar-toggle id="open_sidebar"></b-navbar-toggle> -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <router-link
            class="nav_header"
            :to="{
              name: 'industrial_admin_maintenance',
              query: { companyID: companyID },
            }"
          >
            {{ $t("text.iAdminMasterLayout.hi") }} {{ userName }}
            {{ $t("text.cusMasterLayout.youHave") }}
            <span style="color: green">{{
              genService === 0 ? "no current" : genService
            }}</span>
            {{ $t("text.iGroup.genRequireServicing") }}
          </router-link>
        </b-navbar-nav>
      </b-collapse>
      <b-collapse id="nav-collapse" is-nav>
        <!-- SELECT LANGUAGE -->
        <select
          @change="changeLanguage"
          v-model="usedLang"
          class="w-25 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
        <!-- <select
          @change="changeLanguage"
          class="mr-3"
          style="width: 280px !important"
        >
          <option disabled value="">
            {{ $t("text.cMasterLayout.selectLanguage") }}
          </option>
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select> -->

        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#" class="bell_noti" style="position: relative">
            <img src="@/assets/img/social-media.svg" width="28" />
            <div
              class=""
              style="
                position: absolute;
                right: 0;
                top: -10px;
                height: 65px;
                width: 2px;
                background: lightgrey;
              "
            ></div>
          </b-nav-item>
          <!-- profile and signout -->
          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><img src="@/assets/img/signs (2).svg" width="28"
              /></b>
            </template>
            <b-dropdown-item
              ><router-link
                :to="{
                  name: 'industrial_admin_profile',
                  query: { companyID: this.companyID },
                }"
                >{{ $t("text.cMasterLayout.profile") }}</router-link
              ></b-dropdown-item
            >
            <b-dropdown-item href="#" @click="signOutUser">{{
              $t("text.cMasterLayout.signOut")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item href="#" class="logout_icon mr-4" @click="signOutUser">
            <img src="@/assets/img/signs (2).svg" width="28" />
          </b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="app__wrapper">
      <div class="empty_div"></div>
      <div class="main_content">
        <div class="inner__main_content">
          <slot>
            <router-view />
          </slot>
        </div>
      </div>
    </div>
    <div class="mobile_navbar">
      <div
        class="mobile_navbar_header"
        :style="[
          windowLoc == 'interswitchenergy'
            ? { backgroundColor: '#11386a' }
            : windowLoc == 'rainoil'
            ? { backgroundColor: '#0a0044' }
            : windowLoc == 'eterna'
            ? { backgroundColor: '#007236' }
            : windowLoc == 'bovas'
            ? { backgroundColor: '#b28b00' }
            : null,
        ]"
      >
        <div class="hamburger_menu_div" @click="toggleMobileNav">
          <span class="hamburger_bar"></span>
          <span class="hamburger_bar mt-2"></span>
          <span class="hamburger_bar mt-2"></span>
        </div>
        <div class="epump_logo text-right">
          <img
            src="@/assets/img/epump_white_logo.svg"
            width="150"
            class="m-logo-margin"
          />
        </div>
      </div>
    </div>

    <transition name="mobile-nav-slide-fade">
      <div
        class="mobil_side_drawer"
        v-if="this.$store.getters.getMobileNavDrawer"
        :style="[
          windowLoc == 'interswitchenergy'
            ? { backgroundColor: '#11386a' }
            : windowLoc == 'rainoil'
            ? { backgroundColor: '#0a0044' }
            : windowLoc == 'eterna'
            ? { backgroundColor: '#007236' }
            : windowLoc == 'bovas'
            ? { backgroundColor: '#b28b00' }
            : null,
        ]"
      >
        <div class="logo_section text-right mt-3">
          <img
            src="@/assets/img/close_btn.png"
            width="35px"
            height="35px"
            @click="toggleMobileNav"
          />
        </div>
        <div class="dasboard_type_button_section mt-3 text-center">
          <div class="mobile_epump_logo">
            <img src="@/assets/img/mobieli_white_epump_logo.svg" width="50px" />
          </div>
          <h3 class="mt-2">{{ userName }}</h3>
          <small>{{ userDetails.email }}</small>
        </div>
        <ul class="list-group mt-4">
          <!-- ADMIN DASHBOARD -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_dashboard'
                ? 'navbar_item_active'
                : null,
            ]"
          >
            <router-link
              :to="{
                name: 'industrial_admin_dashboard',
                query: { branchId: this.$route.query.branchId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img
                  alt=""
                  src="@/assets/img/dashboard (1).png"
                  width="20px" /></span
              >{{ $t("text.iAdminMasterLayout.dashboard") }}
            </router-link>
          </li>

          <!-- BRANCHES LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_branches'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Site') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_branches',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/order-processed.svg" width="20px"
              /></span>
              {{ $t("text.iAdminMasterLayout.branches") }}
            </router-link>
          </li>

          <!-- REPORT -->
          <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_admin_report'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Report') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_report',
                query: { companyID: this.companyID },
              }"
              :class="
                activeRoute === 'industrial_admin_report'
                  ? 'navbar_item_active'
                  : ''
              "
              class="vue_router_link"
            >
              <span class="mr-3"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 14 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0V18.2H14V4.62L13.79 4.41L9.59 0.21L9.38 0H0ZM1.4 1.4H8.4V5.6H12.6V16.8H1.4V1.4ZM9.8 2.38L11.62 4.2H9.8V2.38ZM2.8 7V8.4H11.2V7H2.8ZM2.8 10.5V11.9H7.7V10.5H2.8ZM9.1 10.5V11.9H11.2V10.5H9.1ZM2.8 13.3V14.7H7.7V13.3H2.8ZM9.1 13.3V14.7H11.2V13.3H9.1Z"
                    fill="white"
                  />
                </svg>
              </span>
              {{ $t("text.iGroup.report") }}
            </router-link>
          </li>

          <!-- GROUP MANAGEMENT LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_group_management'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              (userInfo.roles.includes('GroupManager') &&
                comPlanFeatures.includes('Group management')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_group_management',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/deal.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.iGroup.groupManagement") }}
              </span>
            </router-link>
          </li>
          <!-- USERS LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_users'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              (userInfo.roles.includes('ManageUsers') &&
                comPlanFeatures.includes('Manage users')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_users',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/users-group.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.iGroup.manageUsers") }}
              </span>
            </router-link>
          </li>

          <!-- MAINTENANCE-->
          <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_admin_maintenance'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Maintenance') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_maintenance',
                query: { companyID: this.companyID },
              }"
              :class="
                activeRoute === 'industrial_admin_maintenance'
                  ? 'navbar_item_active'
                  : ''
              "
              class="vue_router_link"
            >
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span
              ></span>
              {{ $t("text.iGroup.maintenance") }}
            </router-link>
          </li>

          <!-- WALLET LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_admin_wallet'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Wallet') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_wallet',
                query: { companyID: this.companyID },
              }"
              :class="
                activeRoute === 'industrial_branch_wallet_balance'
                  ? 'navbar_item_active'
                  : ''
              "
              class="vue_router_link"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 16 15"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-3"
                style="color: white"
              >
                <path
                  d="M13.4 3.39999H2.15005V2.94999L12.05 2.15799V2.94999H13.4V1.59999C13.4 0.609988 12.5981 -0.0848123 11.6189 0.0546877L2.58205 1.34529C1.60195 1.48569 0.800049 2.40999 0.800049 3.39999V12.4C0.800049 12.8774 0.989691 13.3352 1.32726 13.6728C1.66482 14.0103 2.12266 14.2 2.60005 14.2H13.4C13.8774 14.2 14.3353 14.0103 14.6728 13.6728C15.0104 13.3352 15.2 12.8774 15.2 12.4V5.19999C15.2 4.7226 15.0104 4.26476 14.6728 3.9272C14.3353 3.58963 13.8774 3.39999 13.4 3.39999ZM12.05 9.70539C11.8727 9.70533 11.6971 9.67034 11.5333 9.60242C11.3695 9.5345 11.2206 9.43498 11.0953 9.30953C10.9699 9.18409 10.8705 9.03518 10.8027 8.87132C10.7349 8.70745 10.7 8.53183 10.7 8.35449C10.7001 8.17715 10.7351 8.00155 10.803 7.83773C10.8709 7.67391 10.9705 7.52507 11.0959 7.39971C11.2213 7.27435 11.3703 7.17492 11.5341 7.10711C11.698 7.0393 11.8736 7.00443 12.0509 7.00449C12.4091 7.00461 12.7526 7.147 13.0057 7.40034C13.2589 7.65369 13.4011 7.99723 13.4009 8.35539C13.4008 8.71355 13.2584 9.05699 13.0051 9.31017C12.7517 9.56334 12.4082 9.70551 12.05 9.70539Z"
                  fill="white"
                />
              </svg>
              {{ $t("text.iAdminMasterLayout.wallet") }}
              <!-- <i class="fa fa-angle-right upArrow"></i> -->
            </router-link>
          </li>

          <!-- ORDER MANAGEMENT LINK -->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_order_management'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Order management') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_order_management',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/order-processed.svg" width="20px"
              /></span>
              {{ $t("text.iAdminMasterLayout.orderManagement") }}
            </router-link>
          </li>

          <!-- INVOICES -->
          <!-- <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_invoice'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Invoices') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_admin_invoice',
                query: { companyID: this.companyID },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 14 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0V18.2H14V4.62L13.79 4.41L9.59 0.21L9.38 0H0ZM1.4 1.4H8.4V5.6H12.6V16.8H1.4V1.4ZM9.8 2.38L11.62 4.2H9.8V2.38ZM2.8 7V8.4H11.2V7H2.8ZM2.8 10.5V11.9H7.7V10.5H2.8ZM9.1 10.5V11.9H11.2V10.5H9.1ZM2.8 13.3V14.7H7.7V13.3H2.8ZM9.1 13.3V14.7H11.2V13.3H9.1Z"
                    fill="white"
                  /></svg
              ></span>
              {{ $t("text.cInvoice.title") }}
            </router-link>
          </li> -->

          <!-- SUPPORT-->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : null,
            ]"
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/svg/support.svg" width="20px"
              /></span>

              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.supportAdmin") }}
              </span>
            </router-link>
          </li>

          <!-- SELECT LANGUAGE -->

          <li class="list-group-item treeview" @click="toggleWallet">
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-shopping-bag"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.cMasterLayout.selectLanguage") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul
              class="treeview-menu"
              :style="
                activeDropdown === 'wallet'
                  ? { display: 'block' }
                  : { display: 'none' }
              "
            >
              <li
                style="font-size: 10px"
                class="list-group-item treeview mt-3"
                @click="changeLanguage('en')"
              >
                English
              </li>
              <li
                style="font-size: 10px"
                class="list-group-item treeview mt-3"
                @click="changeLanguage('fr')"
              >
                French
              </li>
            </ul>
          </li>

          <!-- Log out-->
          <li
            style="font-size: 10px"
            class="list-group-item treeview mt-3 mb-3"
            @click="signOutUser"
          >
            <span class="mr-3">
              <img src="@/assets/img/signs (2).svg" width="18"
            /></span>
            {{ $t("text.cusMasterLayout.logout") }}
          </li>
        </ul>
      </div>
    </transition>

    <div>
      <router-link
        class="mobile-nav_header"
        :to="{
          name: 'industrial_admin_maintenance',
          query: { companyID: companyID },
        }"
      >
        {{ $t("text.iAdminMasterLayout.hi") }} {{ userName }}
        {{ $t("text.cusMasterLayout.youHave") }}
        <span style="color: green">{{
          genService === 0 ? "no current" : genService
        }}</span>
        {{ $t("text.iGroup.genRequireServicing") }}
      </router-link>
    </div>
  </div>
</template>

<script>
import JQuery from "jquery";
import backImg from "@/assets/img/pattern_img.png";
import configObject from "@/config";
import WarningModal from "@/components/modals/Dashboard/warningModal";
import SuspendedModal from "@/components/modals/Dashboard/suspendedModal";
let $ = JQuery;

export default {
  title: "Industrial Dashboard",
  name: "AdminMasterLayout",
  components: {
    WarningModal,
    SuspendedModal,
    // StarRating,
  },
  data() {
    return {
      statusInfo: {},
      genService: 0,
      backImg,
      companyID: localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : null,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : { name: "STATION" },
      powerSource: "",
      showWallet: false,
      showReports: false,
      showMaintenance: false,
      activeDropdown: "",
      branch: "Branch",
      branches: null,
      industryBranchName: "",
      industrialBranch: null,
      collapseNavbar: true,
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
      comPlanFeatures: localStorage.getItem("subPlanFeatures")
        ? JSON.parse(localStorage.getItem("subPlanFeatures"))
        : [],
    };
  },
  computed: {
    userName() {
      if (localStorage.getItem("userDetails")) {
        return this.userDetails.firstName + "  " + this.userDetails.lastName;
      } else {
        return "Username";
      }
    },
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
  },
  beforeMount() {
    this.activeRoute = this.$route.name;
  },
  watch: {
    companyID: function (newID, oldID) {
      localStorage.setItem("companyID", newID);
    },
    industrialBranch() {
      this.getPowerStatus();
    },
    branches() {
      const industrialBranch = this.branches.filter(
        (branch) => branch.id == this.$route.query.branchId,
      );
      this.$eventHub.$emit("gotIndustryBranch", true);
      this.$eventHub.$emit("industryBranch", industrialBranch[0]);
    },
  },
  created() {
    if (
      !this.userInfo.roles.includes("SupportAdmin") ||
      this.userInfo.roles.includes("PartnerAdmin") ||
      this.userInfo.roles.includes("IndustryAdmin")
    ) {
      this.getCompany();
    }
  },

  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    // this.getPowerStatus();
    // if (this.windowLoc == "localhost") {
    //   document.getElementById("mlDiv").style.background = "brown";
    // }

    if (
      this.userDetails.roles.includes("SupportAdmin") ||
      this.userDetails.roles.includes("PartnerAdmin")
    ) {
      this.support = true;
      this.companyID = this.$route.query.companyID;
      let ml = sessionStorage.getItem(this.companyID);
      if (!ml) {
        let allData = localStorage.getItem("companiesList");
        let dt = JSON.parse(allData);
        dt.forEach((my, index) => {
          if (my.id === this.companyID) {
            ml = JSON.stringify(my);
            sessionStorage.setItem(this.companyID, ml);
          }
        });
      }

      this.company = JSON.parse(ml);
      this.$eventHub.$emit("company", this.company);
    }

    if (screen.width > 575) {
      $(".treeview > a").on("click", function (e) {
        e.preventDefault();
        var me = $(this);

        if (me.parent("li").hasClass("open")) {
          //close me
          me.parent("li").removeClass("open");
        } else {
          // Open me & close others
          $(".treeview").removeClass("open");
          me.parent("li").addClass("open");
        }
      });
    }

    $(window).scroll(function () {
      if ($(window).scrollTop() > 20) {
        $(".navbar").addClass("navbar-fixed");
      }
      if ($(window).scrollTop() < 20) {
        $(".navbar").removeClass("navbar-fixed");
      }
    });
    if (this.userDetails.role === "IndustryManager") {
      this.getBranch();
    } else {
      this.$eventHub.$emit("gotBranch", true);
    }
    // this.computeUserDetails();
  },
  methods: {
    changeLanguage(e) {
      if (e == "en" || e == "fr") {
        this.$store.commit("setLanguage", e);
        const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
        this.$root.$i18n.locale = locale;
        localStorage.setItem("locale", locale);
        return;
      }

      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },
    getCompany() {
      // console.log("getcompany");
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/MyCompanies`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.companyID = response.data[0].id;

          // Logic for subscription plan feature
          let subPlanFeat;
          let isSubPlanFeat;
          subPlanFeat = response.data[0].planFeatures;
          isSubPlanFeat = localStorage.getItem("subPlanFeatures");
          if (!isSubPlanFeat) {
            localStorage.setItem(
              "subPlanFeatures",
              JSON.stringify(subPlanFeat),
            );
            this.comPlanFeatures = JSON.parse(
              localStorage.getItem("subPlanFeatures"),
            );
          }
          // this.comPlanFeatures = response.data[0].planFeatures;
          // console.log(this.comPlanFeatures);
          // Logic for subscription plan feature ended

          this.getCompanyReorderLevel(response.data[0].id);
          this.getGenService(response.data[0].id);
          this.$eventHub.$emit("company", response.data[0]);
          this.checkStatus();
        })
        .catch((error) => {});
    },
    checkStatus() {
      const modalShown = this.$store.getters.getModalShown;
      if (modalShown) {
        this.statusInfo = this.$store.getters.getStatusInfo;
      }

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.companyID
          }`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.statusInfo = response.data;
          // console.log(response.data);
          if (response.data.status == 1) {
            // console.log(`"check status" ${modalShown}`);
            // conditionally render only once
            if (!modalShown) {
              if (
                !this.userInfo.roles.includes("SupportAdmin") ||
                !this.userInfo.roles.includes("PartnerAdmin")
              ) {
                this.showWarningModal();
                this.$store.commit("setModalShown", true);
              }
            }
          }
          if (response.data.status == 2) {
            if (
              // (this.$route.name !== "industrial_admin_invoice" &&
              //  this.$route.name !== "industrial_admin_invoice_details" &&
              // this.$route.name !== "industrial_admin_invoice_payments" &&
              (this.$route.name !== "industrial_make_payment" &&
                !this.userInfo.roles.includes("SupportAdmin")) ||
              userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showSuspendedModal();
            }
          }
          this.$store.commit("setStatusInfo", response.data);
        })
        .catch((error) => {});
    },
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    showSuspendedModal() {
      this.$modal.show("suspendedModal");
    },
    getCompanyReorderLevel(companyID) {
      // console.log(this.$route.name);
      const prostatShown = this.$store.getters.getProstatShown;
      if (prostatShown) {
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/CompanyProductReorderLevel/${companyID}`,
          configObject.authConfig(),
        )
        .then((response) => {
          // console.log(response.data);
          response.data
            // .filter((fr) => {
            //   return fr.level != "Normal";
            // })
            .forEach((fr) => {
              const frText = `${fr.level} for ${fr.branch}  &#x1F5D9`;
              if (fr.levelPercentage <= 0) {
                this.$toast.open({
                  message: frText,
                  position: "top-right",
                  type: "error",
                  duration: 20000,
                  dismissible: true,
                });
              } else {
                this.$toast.open({
                  message: frText,
                  position: "top-right",
                  type: "warning",
                  duration: 20000,
                  dismissible: true,
                });
              }
            });
          this.$store.commit("setProstatShown", true);
        })
        .catch((error) => {});
    },
    getGenService(companyID) {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Company/NextServiceDay/${companyID}`,
          configObject.authConfig(),
        )
        .then((res) => {
          this.showLoader = false;
          // console.log(res.data);
          let index = 0;
          let genService = res.data.filter((gen) => {
            return gen.totalHour > 700;
          });

          this.genSevice = genService.length;
        });
    },
    toggleWallet() {
      this.showWallet = !this.showWallet;
      if (this.showWallet === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "wallet";
      }
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.iAdminMasterLayout.confirmLogout"),
      );
      if (answer) {
        this.$store.commit("setModalShown", false);
        this.$store.commit("setProstatShown", false);
        this.$store.dispatch("logout");
        this.$router.push({ path: "/" });
      }
    },
    toggleReports() {
      this.showReports = !this.showReports;
      if (this.showReports === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "reports";
      }
    },
    toggleMaintenance() {
      this.showMaintenance = !this.showMaintenance;
      if (this.showMaintenance === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "maint";
      }
    },
    toggleMobileNav() {
      this.$store.commit("toggleMobileNavDrawer");
    },
    getPowerStatus() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerStatus/${this.industrialBranch.id}`,
          configObject.authConfig(),
        )
        .then((res) => {
          if (res.data.source === "Nill") {
            this.powerSource = "No Power Source";
          } else {
            this.powerSource = res.data.source;
          }
        });
    },
    // toggleSidenavText() {
    //   const allListTitles = Array.from(
    //     document.querySelectorAll(".sidenav_list_title")
    //   );
    //   const treeviews = Array.from(document.querySelectorAll(".treeview"));

    //   if (this.collapseNavbar) {
    //     allListTitles.forEach((el) => {
    //       el.style.display = "inline";
    //     });
    //     treeviews.forEach((el) => {
    //       const classList = Array.from(el.classList);
    //       if (classList.includes("open")) {
    //         el.classList.add("open");
    //         el.classList.remove("list_open");
    //       }
    //     });
    //   }
    // },
    // hideTitles() {
    //   const allListTitles = Array.from(
    //     document.querySelectorAll(".sidenav_list_title")
    //   );

    //   Array.from(document.querySelectorAll("li")).forEach((li) => {
    //     li.classList.remove("open");
    //   });

    //   if (this.collapseNavbar) {
    //     allListTitles.forEach((el) => {
    //       el.style.display = "none";
    //     });
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/styles_new.scss";
li {
  font-size: 1em !important;
}
@media only screen and (max-width: 1378px) {
  .side__bar {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 600px) {
  .inner__main_content {
    margin-top: 70px !important;
  }

  .mobile-nav_header {
    font-size: 13px;
    color: black;
    background-color: white;
    width: 100%;
    position: fixed;
    padding: 20px 10px;
    top: 60px;
  }
}

@import url("https://cdn.syncfusion.com/ej2/material.css");
</style>
